import React from 'react'
import {
  Card,
  BodyText,
  CaptionText,
  CodeIcon,
  Button,
  FlashIcon,
} from '@paypalcorp/pp-react'
import { useNavigate } from 'react-router-dom'
import { useAnalytics } from '../../analytics/analytics-context'

const base64Encode = (str) => {
  return btoa(str)
}

const AppCard = ({ app }) => {
  const navigate = useNavigate()
  const { trackPress } = useAnalytics()

  const handleClick = () => {
    const paramsObject = {
      ...app,
    }

    const applicationId = base64Encode(app.app_name)
    const jsonString = JSON.stringify(paramsObject)
    const encodedParams = base64Encode(jsonString)

    const url = `/upgrade-your-apps/upgrade-guide/${applicationId}?encodedParams=${encodedParams}`

    trackPress({
      component: 'upgrade_banner_button',
      button_label: 'View Upgrade Guide',
      redirectUrl: url,
      currentIntegration: app.current_integration,
      recommendedIntegration: app.recommended_integration,
      paymentIntent: app.payment_intents?.[0]?.intent_type,
    })
    navigate(url)
  }

  return (
    <Card className="app-card">
      <BodyText id="oneTimeCheckout" strong>
        {app.app_name}
      </BodyText>
      <div className="app-details">
        <CodeIcon className="icon-code" size="xs" />
        <CaptionText strong id="current-title">
          Current:
        </CaptionText>
        <CaptionText id="current-integration" data-testid="current-integration">
          {app.current_integration}
        </CaptionText>
      </div>
      <div className="app-details">
        <FlashIcon className="icon-flash" size="xs" />
        <CaptionText strong id="upgrade-to-title">
          Upgrade to:
        </CaptionText>
        <CaptionText id="upgrade-to" data-testid="recommended-integration">
          {app.recommended_integration}
        </CaptionText>
      </div>
      <Button
        onClick={handleClick}
        className="upgrade-button"
        secondary
        size="sm"
        id="view-upgrade-guide"
      >
        View Upgrade Guide
      </Button>
    </Card>
  )
}

export default AppCard
